import HeaderMenuDivide from "../../../assets/img/top_menu_dividers_shine_effect.png";
import HeaderMenuDivideRev from "../../../assets/img/top_menu_dividers_shine_effect-rev.png";
import React, {memo, useCallback} from "react";
import DropDownItem from "./DropDownItem";
import CustomHistory from "../../../CustomHistory";
import {useHistory} from "react-router-dom";
import {config, FrontendRoutes} from "../../../constants";

const DropDownContent = ({open, setOpen}) => {
    const history = useHistory()

    const handleFeedback = useCallback(() => {
        history.push(FrontendRoutes.FEEDBACK);
        setOpen(false)
    }, []);

    const handleLogout = useCallback(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        history.push(FrontendRoutes.LOGOUT)
        setOpen(false)
    }, []);

    if(!open)
        return null;

    return (<div className="dropdown-content">
        {config.SHOW_FEEDBACK && <DropDownItem label={'Feedback'} onClick={handleFeedback}/>}
        <DropDownItem label={'Logout'} onClick={handleLogout}/>
    </div>);
}

export default memo(DropDownContent)